import React, { useState, useEffect } from "react";
import ReportsDashboard from "./NewHRMSReports/Pages/ReportsDashboard";

const HRMSReports = () => {
  return (
    <>
      <ReportsDashboard />
    </>
  );
};

export default HRMSReports;
